import { useStateWithRef } from "@kalyzee/kast-app-web-components";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import PageContainer from "../../components/page/PageContainer";
import { OvenMediaContext } from "../../interfaces/context";
import { useOvenMediaContexts } from "../../store/context/hooks";
import { useMultiServer } from "../../store/session/hooks";
import styles from "./bullmq-admin.module.css";
import { getBullMQAdminInterfaceUrl } from "../../helpers/request";

const generateUrls = (context: OvenMediaContext) => {
  if (!context?.bullMQAdminInterface) return undefined;
  const url = getBullMQAdminInterfaceUrl(context);
  if (!url) return undefined;
  const urlWithUser = new URL(url);
  if (context.bullMQAdminInterface?.user) {
    urlWithUser.password = context.bullMQAdminInterface.user.password;
    urlWithUser.username = context.bullMQAdminInterface.user.user;
  }
  return { url: new URL(url), urlWithUser, username: context.bullMQAdminInterface?.user?.user, password: context.bullMQAdminInterface?.user?.password };
};

const BullMQAdminPage = () => {
  const multiServer = useMultiServer();
  const contexts = useOvenMediaContexts();
  const [currContext, setCurrContext] = useStateWithRef<OvenMediaContext | undefined>();

  const renderContent = (context: OvenMediaContext) => {
    const result = generateUrls(context);
    if (!result) {
      return <div style={{ color: "black" }}>L'interface admin n'est pas activée ou configurée...</div>;
    }
    return (
      <>
        <a style={{ width: "100%" }} href={result.urlWithUser.href} target="_blank">
          Ouvrir dans un nouvel onglet (Cliquez ici pour vous logger automatiquement)
        </a>
        <iframe style={{ width: "100%", height: "100%" }} src={result.url.href} />
      </>
    );
  };

  return (
    <PageContainer title={"BullMQ - Interface Admin" /* TRANSLATION */} subtitle={""} loading={false}>
      {multiServer ? (
        <Tabs
          className={[styles.tabs].join(" ")}
          onSelect={(index) => {
            const context = index < contexts.length ? contexts[index] : undefined;
            setCurrContext(context);
          }}
        >
          <TabList>
            {contexts.map((c) => (
              <Tab key={`logs_tab_${c.server._id}`}>{`Server ${c.server._id}`}</Tab>
            ))}
          </TabList>
          {contexts.map((c) => (
            <TabPanel className={[styles.tabsContent, "react-tabs-content"].join(" ")} key={`logs_content_${c.server._id}`}>
              {renderContent(c)}
            </TabPanel>
          ))}
        </Tabs>
      ) : (
        renderContent(contexts[0])
      )}
    </PageContainer>
  );
};

export default BullMQAdminPage;
